import { jsx as _jsx } from "react/jsx-runtime";
import { useMountEffect } from '@vista-digital/react-tools';
import Fuse from 'fuse.js';
import { forwardRef, useCallback, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Input } from '../input/input';
// This doesn't currently warrant making configurable. If required in future, replace as appropriate.
const maxSearchInputLength = 512;
const SearchInputBase = (props, forwardedRef) => {
    const inputRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResult, setSearchResult] = useState();
    const { onComponentWillUnmount, onResultsChanged, onSearchTermChanged, searchValues, searchOptions, searchKeys } = props;
    const fuse = useMemo(() => {
        return new Fuse(searchValues, Object.assign({ shouldSort: true, threshold: 0.4, location: 0, distance: 100, fieldNormWeight: 0, minMatchCharLength: 1, keys: searchKeys }, searchOptions));
    }, [searchValues, searchOptions, searchKeys]);
    const search = useCallback((newSearchTerm) => {
        const isEmptySearch = newSearchTerm.trim().length === 0;
        const results = isEmptySearch ? undefined : fuse.search(newSearchTerm).map(r => r.item);
        if (!areResultsEqual(results, searchResult)) {
            setSearchResult(results);
            onResultsChanged(results);
        }
    }, [fuse, searchResult, onResultsChanged]);
    useMountEffect(() => {
        search(searchTerm);
        return () => {
            onComponentWillUnmount === null || onComponentWillUnmount === void 0 ? void 0 : onComponentWillUnmount();
        };
    });
    const handleChange = useCallback((newValue) => {
        setSearchTerm(newValue);
        search(newValue);
        onSearchTermChanged === null || onSearchTermChanged === void 0 ? void 0 : onSearchTermChanged(newValue);
    }, [search, onSearchTermChanged]);
    useImperativeHandle(forwardedRef, () => ({
        focus: () => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        },
        setSearchTerm: (term) => {
            handleChange(term);
        }
    }));
    return (_jsx(Input, Object.assign({ ref: inputRef }, props, { maxLength: maxSearchInputLength, value: searchTerm, onChangeValue: handleChange })));
};
const areResultsEqual = (newResults, oldResults) => {
    if (!oldResults && !newResults) {
        return true;
    }
    if (!oldResults || !newResults || oldResults.length !== newResults.length) {
        return false;
    }
    return oldResults.every((result, index) => newResults[index] === result);
};
/**
 * Renders the search input component.
 * Note: onResultsChanged will be called with undefined when the search term is empty.
 */
export const SearchInput = forwardRef(SearchInputBase);
SearchInput.displayName = 'SearchInput';
//# sourceMappingURL=search-input.js.map